// Copyright (c) 2025 Audere, All Rights Reserved

import { Box, Button, Grid, Tooltip, Typography } from "@mui/material";
import { useParams } from "react-router";

import type { ProjectItemsProps } from "../types/projects";
import folderOpenUrl from "../../assets/folder_open.svg";
import folderOpenLightUrl from "../../assets/folder_open_light.svg";
import { theme } from "../../theme";
import { createStyleSheet } from "../utils/styles";

const ProjectItems = ({ projects, onProjectSelect }: ProjectItemsProps) => {
  const { projectUid: selectedProjectUid } = useParams();

  return (
    <Grid container spacing={2} sx={styles.projectsGridContainer}>
      {projects.map(project => {
        const isSelected = selectedProjectUid === project.project_uid;

        return (
          <Grid size={{ xs: 12, sm: 6, md: 4 }} key={project.project_uid}>
            <Button
              variant={isSelected ? "contained" : "outlined"}
              onClick={() => onProjectSelect(project.project_uid)}
              startIcon={
                <Box
                  component="img"
                  src={isSelected ? folderOpenLightUrl : folderOpenUrl}
                  sx={styles.folderOpenImg}
                  alt="Folder Open"
                />
              }
              fullWidth
              sx={{
                ...styles.projectSelectBtn,
                background: isSelected ? theme.palette.primary.main : theme.palette.common.white,
              }}
            >
              <Tooltip title={project.name} arrow>
                <Typography
                  variant="body1bold"
                  sx={{
                    ...styles.projectNameText,
                    color: isSelected ? theme.palette.common.white : theme.palette.text.primary,
                  }}
                  noWrap
                >
                  {project.name}
                </Typography>
              </Tooltip>
            </Button>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default ProjectItems;

const styles = createStyleSheet({
  projectsGridContainer: { mt: 2 },
  folderOpenImg: { height: 20, objectFit: "contain" },
  projectSelectBtn: {
    justifyContent: "flex-start",
    textTransform: "none",
    borderColor: theme.palette.grey[400],
    px: 2,
    py: 2.5,
  },
  projectNameText: {
    ml: 1,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    flex: 1,
    minWidth: 0,
    textAlign: "left",
  },
});
